import { render, staticRenderFns } from "./product6.vue?vue&type=template&id=22a30c46&scoped=true"
import script from "./product6.vue?vue&type=script&lang=js"
export * from "./product6.vue?vue&type=script&lang=js"
import style0 from "./product6.vue?vue&type=style&index=0&id=22a30c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a30c46",
  null
  
)

export default component.exports